import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';

function RedirectComponent({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

function App() {
  const location = useLocation();

  // Handle specific routes
  if (location.pathname === '/privacy-policy') {
    return <RedirectComponent to="https://www.payshift.io/politique-de-confidentialite" />;
  }

  if (location.pathname === '/terms-and-conditions') {
    return <RedirectComponent to="https://www.payshift.io/conditions-generales" />;
  }

  // Handle all other routes - redirect to www.payshift.io
  return <RedirectComponent to="https://www.payshift.io" />;
}

export default App;

